export default __webpack_public_path__ + "static/media/barn.dfbe65d4.png";